/* unplugin-vue-components disabled */import script from "./DepositManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositManager.vue?vue&type=script&setup=true&lang=js"

import "./DepositManager.vue?vue&type=style&index=0&id=323372c5&lang=scss"

const __exports__ = script;

export default __exports__